import { Analytics, AnalyticsCallOptions, CustomEventName, logEvent } from "firebase/analytics";

export class AnalyticsService {
  constructor(private analytics: Analytics) {}

  event<T extends string>(
    eventName: CustomEventName<T>,
    eventParams?: {
      [key: string]: any;
    },
    options?: AnalyticsCallOptions,
  ): void {
    if (process.env.NODE_ENV === "development") {
      eventParams ? console.log(`[EVENT] ${eventName}`, eventParams) : console.log(`[EVENT] ${eventName}`);
      return;
    }
    logEvent(this.analytics, eventName, eventParams, options);
  }
}
